import React from 'react';
import styles from './onboarding-users-preview.module.css';
import { Anchor, Button } from '@keplerco/core';
import layoutStyles from '../../../../design/layout.module.css';
import classNames from 'classnames';
import { useAppActions, useAppState } from '../../../../overmind';
import { EntitiesCardWidget } from '../../../../components/cards/entities-card.widget';
import { PagePath } from '../../../../navigation/navigation.enums';
import { FreemiumPeopleCMSLayout } from '../../freemium-people/freemium-people.cms.layout';

export interface IOnboardingUsersPreviewPageProps {
  onBack: () => void;
  onNext: () => void;
}
export function OnboardingUsersPreviewPage(props: IOnboardingUsersPreviewPageProps): JSX.Element {
  // Self-contained state
  const { freemiumAccount } = useAppState();

  const actions = useAppActions();
  return !!freemiumAccount ? (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24, width: '100%' }}>
      <EntitiesCardWidget title="Upload users" description="Upload up to 10 users">
        <FreemiumPeopleCMSLayout onLoad={async () => await actions.getFreemiumAccount()} path={PagePath.userManagementPeople} slugs={{ companySlug: freemiumAccount.companySlug }} type="company" />
      </EntitiesCardWidget>
      <footer className={classNames('card', layoutStyles.wizardFooter)}>
        <Anchor className={styles.anchor} onClick={() => props.onBack()}>
          Back
        </Anchor>
        <Button type="button" filled onClick={async () => {
          await actions.completeUserUpload();
          await actions.getFreemiumAccount();
          props.onNext();
        }}>
          {freemiumAccount?.userCount > 0 ? 'Confirm users' : 'Skip'}
        </Button>
      </footer>
    </div>
  ) : <></>;
}
